import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { JoinRequest } from './join-request.model';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { SignupJoinRequest } from '../../models/access/signup/signup-join-request.model';

@Injectable({
    providedIn: 'root',
})
export class JoinService
{
    constructor(
        private _http: ApplicationHttpClient,
    ) {}

    joinHoa(joinRequest: JoinRequest|SignupJoinRequest): Observable<Object> {
        return this._http.post(
            Routes.MakeLegFiCoreUrl(Routes.LegFiCore.Join),
            JSON.stringify(joinRequest),
        );
    }

    checkEmail(email: string): Observable<Object> {
        return this._http.get(Routes.MakeLegFiCoreUrl(`${Routes.LegFiCore.Join}/${email}`));
    }

    checkOrgEmail(organizationId: number, email: string): Observable<Object> {
        return this._http.get(Routes.MakeLegFiCoreUrl(`${Routes.LegFiCore.Organization(organizationId)}/check/${email}`));
    }

    searchOrg(name: string): Observable<Object> {
        return this._http.get(Routes.MakeLegFiCoreUrl(`${Routes.LegFiCore.Organizations}/onboarding/search/${name}`));
    }

    getOrgById(id: number): Observable<{id: number; name: string; hasLogo: boolean;}> {
        return this._http.get(Routes.MakeLegFiCoreUrl(`${Routes.LegFiCore.Organizations}/onboarding/${id}`));
    }
}
